import Constants from '@/constant'
// states
const _state = {

}

// getters
const _getters = {
  isTakeOverToolbarVisible: (_, __, rootState, rootGetters) => {
    const isPresentingWithPPT = rootState.isEnableAddinPowerpoint && rootGetters.isPresenting
    const hasEditPermissions = rootState.presentation.permissions &&
    rootState.presentation.permissions.includes(Constants.permissions.RENAME_PRESENTATION)
    const isTakenOverByAnotherUser = rootState.presentation.takenOverBy !== rootState.currentUser.id
    return !isPresentingWithPPT && (!hasEditPermissions || (hasEditPermissions && isTakenOverByAnotherUser))
  },
}

// mutations
const mutations = {

}

// actions
const actions = {

}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
